/**
 * 路由上报配置
 * 统一管理每个页面的上报 pgid
 */

export interface RouteReportConfig {
  /** 路由路径匹配模式 */
  pattern: string | RegExp;
  /** 上报页面 ID */
  pgid: string;
  /** 页面描述（可选，用于调试） */
  description?: string;
}

/**
 * 路由上报配置列表
 * 优先级：从上到下匹配，先匹配到的优先
 */
export const ROUTE_REPORT_CONFIGS: RouteReportConfig[] = [
  // 首页
  { pattern: '/', pgid: 'home', description: '首页' },

  // 频道页
  { pattern: /^\/channel(\/|$)/, pgid: 'channel', description: '频道页' },

  // 账号相关
  { pattern: '/account/phone-login', pgid: 'phoneLogin', description: '手机号登录' },
  { pattern: '/account/email-login', pgid: 'emailLogin', description: '邮箱登录' },
  { pattern: '/account/password-login', pgid: 'passwordLogin', description: '密码登录' },
  { pattern: '/account/to-app-reg', pgid: 'toAppReg', description: 'App注册引导' },
  { pattern: /^\/account(\/|$)/, pgid: 'account', description: '账号页' },

  // 搜索
  { pattern: /^\/search(\/|$)/, pgid: 'search', description: '搜索页' },

  // 筛选页
  { pattern: /^\/more(\/|$)/, pgid: 'filter', description: '筛选页' },

  // 播放相关
  { pattern: /^\/play\//, pgid: 'play', description: '播放页' },
  { pattern: /^\/playDetail\//, pgid: 'playDetail', description: '播放详情页' },

  // 功能页面
  { pattern: '/settings', pgid: 'settings', description: '设置页' },
  { pattern: '/history', pgid: 'history', description: '历史记录' },
  { pattern: '/about/software-info', pgid: 'softwareInfo', description: '软件信息' },
  { pattern: '/about', pgid: 'about', description: '关于页' },
  { pattern: '/help-feedback', pgid: 'helpFeedback', description: '帮助反馈' },

  // 会员相关
  { pattern: '/vip/openRes', pgid: 'vipOpenResult', description: '会员开通结果' },
  { pattern: /^\/vip\/open(\/|$)/, pgid: 'vipOpen', description: '会员开通页' },

  // 彩蛋页
  { pattern: '/about/easter-egg', pgid: 'easter_egg', description: '彩蛋页' },
];

/**
 * 默认页面 ID（未匹配到时使用）
 */
export const DEFAULT_PGID = 'unknown';

/**
 * 根据路由路径获取对应的 pgid
 */
export function getPgidByPath(pathname: string): string {
  for (const config of ROUTE_REPORT_CONFIGS) {
    const { pattern, pgid } = config;

    if (typeof pattern === 'string') {
      if (pathname === pattern) {
        return pgid;
      }
    } else if (pattern instanceof RegExp) {
      if (pattern.test(pathname)) {
        return pgid;
      }
    }
  }

  return DEFAULT_PGID;
}
